import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { Link } from 'react-router-dom';

import { Chip } from '@feathr/components';
import { useLocalUrl, useStore } from '@feathr/extender/state';
import { campaignColorMap } from '@feathr/extender/styles/campaign';

import { getCampaignIcon } from '../CampaignIcons';

interface IProps {
  id: string;
  linkToItem?: boolean;
}

function CampaignChip({ id, linkToItem = true }: IProps): JSX.Element | null {
  const { Campaigns } = useStore();
  const localUrl = useLocalUrl();

  if (!id) {
    return null;
  }

  const campaign = Campaigns.get(id);

  if (campaign.isErrored) {
    return null;
  }

  if (campaign.isPending) {
    return <Chip isLoading={true} />;
  }

  const type = campaign.get('_cls');
  const content = (
    <Chip prefix={getCampaignIcon(type)} theme={campaignColorMap.get(type)}>
      {campaign.name}
      {campaign.get('is_archived') ? ' (Archived)' : ''}
    </Chip>
  );

  if (linkToItem) {
    return <Link to={localUrl(campaign.getItemUrl())}>{content}</Link>;
  }
  return content;
}

export default observer(CampaignChip);
